import { getSelectedDistrict, getSelectedSport } from 'app/imports/App.selectors'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export function LayoutHeaderDistrict() {
  const district = useSelector(getSelectedDistrict)
  const selectedSport = useSelector(getSelectedSport)

  const title = useMemo(() => {
    if (!district || district.length === 0) return ''

    if (district.length > 1) return ''

    let result = district[0].name
    if (selectedSport && selectedSport.length > 0) {
      if (selectedSport.length === 1) {
        result += ` ${selectedSport[0].name}`
      }
    }

    return result
  }, [district, selectedSport])

  if (!district || district.length === 0) {
    return null
  }

  return (
    <>
      <title>{`Scoreboard | ${title}`}</title>
      {title}
    </>
  )
}
